import { FC } from "react"

export const CircleMarker: FC<{ color: string }> = ({ color }) => (
  <svg width="16" height="16" viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="8" fill={color} />
  </svg>
)
